import { render, staticRenderFns } from "./cashierReceiptsMachineSettings.vue?vue&type=template&id=70f1f0f4&"
import script from "./cashierReceiptsMachineSettings.vue?vue&type=script&lang=js&"
export * from "./cashierReceiptsMachineSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports